import axios from '@/plugins/axios';

export const saveToCartOrderReminderPR = async (
  customerCode,
  customerId,
  orderConcept,
  cart,
  typeBack,
  type = 'CL'
) => {
  const { data } = await axios.post('/save-order-info-reminder-pr', {
    customer_id: customerCode,
    orden_compra: orderConcept,
    destiny: customerCode,
    cart: cart,
    user_id: customerId,
    type,
    type_back: typeBack,
  });

  return data;
};

export const saveToCartOrderReminderDT = async (
  customerCode,
  customerId,
  orderConcept,
  cart,
  typeBack,
  type = 'CL'
) => {
  const { data } = await axios.post('/saveOrderInfoReminder', {
    customer_id: customerCode,
    orden_compra: orderConcept,
    destiny: customerCode,
    cart: cart,
    user_id: customerId,
    type,
    type_back: typeBack,
  });

  return data;
};

export const generatePurchaseOrderId = async (
  orderType = 'normal',
  channel = ''
) => {
  const { data } = await axios.post('/generate-purchase-order-id', {
    orderType,
    channel,
  });
  return data.purchaseOrder;
};

export const getRecentOrders = async (userCode, role, channel) => {
  const { data } = await axios.get('/recent-orders', {
    params: {
      user_code: userCode,
      channel,
      role,
    },
    noCancelRequest: true,
  });

  return data.data.map((order) => {
    return {
      ...order,
      ...order.userScopeDownline,
    };
  });
};

export const updateRecentOrder = async (
  userId,
  userRole,
  customerCode,
  channel,
  id,
  orderData = { total: null, subtotal: null, tax: null, name: null }
) => {
  const { data } = await axios.put(`/recent-orders/${id}`, orderData, {
    params: {
      user_id: userId,
      role: userRole,
      customer_code: customerCode,
      channel,
    },
    noCancelRequest: true,
  });

  return {
    ...data.data,
    ...data.data.userScopeDownline,
  };
};

export const recentOrderValidity = async (id, channel) => {
  const validity = await axios.get(`/recent-orders/${id}/validity`, {
    params: {
      channel,
    },
    noCancelRequest: true,
  });

  return validity.data;
};

export const removeRecentOrders = async (userId, channel, ids) => {
  await axios.delete('/recent-orders', {
    params: {
      user_id: userId,
      channel,
      ids,
    },
  });

  return;
};
